import './MapCMFeaturePopup.less';
import { useAppDispatch, useAppSelector } from '../../../store/hooks/hooks';
import { Popup } from 'react-map-gl';
import {
  FeatureSelectedMode,
  selectFeatureSelected, selectFeatureSelectedMode,
  unselectFeature,
} from '../../../store/slice/mapLayersSlice';
import { Feature } from '../../../models/Geoserver';
import { useMemo } from 'react';
import { getLineStringCenter, getPolygonCenter } from '../../../utils/GeometryUtils';
import attributesConfig from '../../../config/layer_attributes.json'

function MapCMFeaturePopup() {
  const featureSelected: Feature | undefined = useAppSelector(
    selectFeatureSelected,
  );
  const mode: FeatureSelectedMode = useAppSelector(
    selectFeatureSelectedMode,
  );
  const dispatch = useAppDispatch();

  const coordinate = useMemo(() => {
    if(featureSelected?.geometry?.type === 'Point') {
      return featureSelected.geometry.coordinates;
    } else if(['MultiPolygon', 'Polygon'].includes(featureSelected?.geometry?.type as string)) {
      return getPolygonCenter(featureSelected);
    } else if(['MultiLineString', 'LineString'].includes(featureSelected?.geometry?.type as string)){
      return getLineStringCenter(featureSelected)
    }
    return [0,0]
  }, [featureSelected])

  if (!featureSelected || mode !== 'view-attributes') return null;

  const config: any = attributesConfig.layers.find(l => l.layerName === featureSelected!.layer);
  if(!config){
    return null;
  }

  const attributes: any = config.attributes;
  const xlsAttributes: any = config.xlsAttributes ?? {};

  if(!Object.keys(attributes) && !Object.keys(xlsAttributes)){
    return null;
  }

  return (
    <div className="at-map-cm-feature-popup__container">
      <Popup
        key={featureSelected.id}
        closeOnClick={false}
        closeOnMove={false}
        focusAfterOpen={true}
        closeButton={false}
        longitude={coordinate[0]}
        latitude={coordinate[1]}
        anchor="bottom"
        maxWidth={'400px'}
      >
        <h1 className="at-map-cm-feature-popup__title">
          {featureSelected.layer}
        </h1>
        <div className="at-map-cm-feature-popup__description">
          {
            Object.keys(attributes).map(key => (
              <div key={key}>
                <b>{attributes[key]}:</b> {(featureSelected!.properties as any)[key] ? (featureSelected!.properties as any)[key] : '-'}
              </div>
            ))
          }
          {
            Object.keys(xlsAttributes).map(key => (
              <div key={key}>
                <b>{xlsAttributes[key]}:</b> {
                key
                  .split('.')
                  .reduce((a, b) => a?.[b], featureSelected.atriutosRegistros ?? {} as any) ?? '-'
                }
              </div>
            ))
          }
        </div>
      </Popup>
    </div>
  );
}

export default MapCMFeaturePopup;
